export const FETCH_SERVICE = "FETCH_SERVICE";
export const FETCH_SERVICE_SUCCESS = "FETCH_SERVICE_SUCCESS";
export const FETCH_SERVICE_FAILURE = "FETCH_SERVICE_FAILURE";

export const CREATE_SERVICE_REQUEST = "CREATE_SERVICE_REQUEST";
export const CREATE_SERVICE_SUCCESS = "CREATE_SERVICE_SUCCESS";
export const CREATE_SERVICE_FAILURE = "CREATE_SERVICE_FAILURE";

export const CHANGE_SERVICE_STATUS = "CHANGE_SERVICE_STATUS";
export const CHANGE_SERVICE_STATUS_SUCCESS = "CHANGE_SERVICE_STATUS_SUCCESS";
export const CHANGE_SERVICE_STATUS_FAILURE = "CHANGE_SERVICE_STATUS_FAILURE";

export const DELETE_SERVICE = "DELETE_SERVICE";
export const DELETE_SERVICE_SUCCESS = "DELETE_SERVICE_SUCCESS";
export const DELETE_SERVICE_FAILURE = "DELETE_SERVICE_FAILURE";

export const GENERATE_SERVICE_CODE = "GENERATE_SERVICE_CODE";
export const GENERATE_SERVICE_CODE_SUCCESS = "GENERATE_SERVICE_CODE_SUCCESS";
export const GENERATE_SERVICE_CODE_FAILURE = "GENERATE_SERVICE_CODE_FAILURE";
